export const TEXT_MIXIN_BY_BUTTON_INLINE_SIZE_MAP = {
    "16": "caption-m",
    "20": "body-m",
    "24": "body-l",
    "32": "body-l",
} as const;
